
      var _defs, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStampa1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 73,
  height: 73,
  viewBox: "0 0 73 73"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "stampa-1_20fd4901b45a9c07__a",
  x1: "76.324%",
  x2: "32.709%",
  y1: "91.11%",
  y2: "3.429%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%"
})))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 36.958,
  cy: 36.295,
  r: 36,
  fill: "url(#stampa-1_20fd4901b45a9c07__a)",
  fillRule: "evenodd"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"73\" height=\"73\" viewBox=\"0 0 73 73\">\r\n    <defs>\r\n        <linearGradient id=\"8zzksj8fla\" x1=\"76.324%\" x2=\"32.709%\" y1=\"91.11%\" y2=\"3.429%\">\r\n            <stop offset=\"0%\" stop-color=\"#000000\"/>\r\n            <stop offset=\"100%\" stop-color=\"#000000\"/>\r\n        </linearGradient>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g transform=\"translate(-36 -599) translate(36 599)\">\r\n                <circle cx=\"36.958\" cy=\"36.295\" r=\"36\" fill=\"url(#8zzksj8fla)\"/>\r\n             \r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/stampa-1.20fd4901b45a9c07b3b08f8fb4f279d3.svg"),
        {
          React: SvgStampa1,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      